import React from 'react'
import {Switch,Route} from 'react-router-dom'
import Login from './Login'

export default function Render() {
	return (
		<Switch>
			<Route exact path="/scanner" component={Login}/>
		</Switch>
	)
}
